import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[integerOnly]'
})
export class IntegerOnlyDirective {
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (event.key === ',' || event.key === '.') {
      event.preventDefault();
    }
  }
}
